export default __webpack_public_path__ + "static/media/arrow-right.6658ce6a.svg";